/** Prepare rechecks whether a new connection is still needed before admission is recorded. */
export type ConnectionAdmission = (prepare: () => (() => void) | undefined) => Promise<boolean>

export class ConnectionAdmissionSkippedError extends Error {
  constructor() {
    super('Automatic connection was deferred.')
    this.name = 'ConnectionAdmissionSkippedError'
  }
}

export function isConnectionAdmissionSkipped(error: unknown): boolean {
  return (
    error instanceof ConnectionAdmissionSkippedError ||
    (error instanceof Error && error.cause instanceof ConnectionAdmissionSkippedError)
  )
}
